import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './SearchFiltersContainer.scss';
const rootClassName = styles.rootClassName;

class SearchFiltersContainer extends Component {
  getClassNames() {
    let classes = [rootClassName];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return classes.join(' ');
  }

  render() {
    return <div className={this.getClassNames()}>{this.props.children}</div>;
  }
}

SearchFiltersContainer.propTypes = {
  className: PropTypes.string,
};

export default SearchFiltersContainer;
